import { render, staticRenderFns } from "./Tab1General.vue?vue&type=template&id=2a859e26&scoped=true&"
import script from "./Tab1General.vue?vue&type=script&lang=js&"
export * from "./Tab1General.vue?vue&type=script&lang=js&"
import style0 from "./Tab1General.vue?vue&type=style&index=0&id=2a859e26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a859e26",
  null
  
)

export default component.exports